import { render, staticRenderFns } from "./JournalDeliveryOfSamples.vue?vue&type=template&id=0d651b02&scoped=true"
import script from "./JournalDeliveryOfSamples.vue?vue&type=script&lang=js"
export * from "./JournalDeliveryOfSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d651b02",
  null
  
)

export default component.exports